import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import WingsDropDown from "../Shared/WingsDropDown";
import { toast, ToastContainer } from "react-toastify";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import ReportsMenu from "./ReportsMenu";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionsDropDown from "../Shared/SectionDropDown";
import { scrollToTop } from "../Shared/ScrollOnTop";
import csvDownload from "json-to-csv-export";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PromotionReport = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [showFilters, setShowFilters] = useState(true);

  const [loading, setLoading] = useState(false);
  const [promotedStudents, setPromotedStudents] = useState([]);
  const [validated, setValidated] = useState(false);
  const [loaddata, setLoaddata] = useState(false);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  // Filter states
  const [oldWingId, setOldWingId] = useState(0);
  const [newWingId, setNewWingId] = useState(0);
  const [oldClassId, setOldClassId] = useState(0);
  const [newClassId, setNewClassId] = useState(0);
  const [oldSectionId, setOldSectionId] = useState(0);
  const [newSectionId, setNewSectionId] = useState(0);
  const [registrationNo, setRegistrationNo] = useState("");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [isActive, setIsActive] = useState(null);
  const [schoolName, setSchoolName] = useState("");
  const [logoImage, setLogoImage] = useState("");

  useEffect(() => {
    document.title = "Promotion Report";
    fetchPromotedStudents();
  }, [
    pageNo,
    pageSize,
    oldWingId,
    newWingId,
    oldClassId,
    newClassId,
    oldSectionId,
    newSectionId,
    registrationNo,
    dateFrom,
    dateTo,
    isActive,
  ]);

  const fetchPromotedStudents = () => {
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      OldWing_Id: oldWingId,
      NewWing_Id: newWingId,
      OldClass_Id: oldClassId,
      NewClass_Id: newClassId,
      OldSection_Id: oldSectionId,
      NewSection_Id: newSectionId,
      Student_ID: registrationNo,
      DateFrom: dateFrom,
      DateTo: dateTo,
      Is_Active: isActive,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Reports/GetPromotedStudentsDetails",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setPromotedStudents(response.data.ListofRecords);
          setTotalRecords(response.data.totalRecords);
          setSchoolName(response.data.SchoolName);
          setLogoImage(response.data.LogoImage);
          setLoading(false);
        } else {
          setPromotedStudents([]);
          setLoading(false);
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        toast.error("Network Error", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handleSubmitForCvs = () => {
    setLoaddata(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 100000,
      OldWing_Id: oldWingId,
      NewWing_Id: newWingId,
      OldClass_Id: oldClassId,
      NewClass_Id: newClassId,
      OldSection_Id: oldSectionId,
      NewSection_Id: newSectionId,
      RegistrationNo: registrationNo,
      DateFrom: dateFrom,
      DateTo: dateTo,
      Is_Active: isActive,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Reports/GetPromotedStudentsDetails",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          if (response.data.totalRecords > 0) {
            const dataToConvert = {
              data: response.data.ListofRecords,
              filename: "PromotedStudentsReport",
              delimiter: ",",
              headers: [
                "Serial_No",
                "ID",
                "Student_Name",
                "Father_Name",
                "Date",
                "Old_Wing",
                "Old_Class",
                "Old_Section",
                "New_Wing",
                "New_Class",
                "New_Section",
                "Promoted_By",
              ],
            };
            csvDownload(dataToConvert);
            setLoaddata(false);
          } else {
            toast.error("There is no data available for download", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setLoaddata(false);
          }
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoaddata(false);
        }
      })
      .catch(function (error) {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoaddata(false);
      });
  };

  const renderPromotedStudents = () => {
    if (promotedStudents && promotedStudents.length > 0) {
      return promotedStudents.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Serial_No}</td>
            <td>{item.Student_ID}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Father_Name}</td>
            <td>{moment(item.Date).format("DD-MM-YYYY")}</td>
            <td>{item.OldWing}</td>
            <td>{item.OldClass}</td>
            <td>{item.OldSection}</td>
            <td>{item.NewWing}</td>
            <td>{item.NewClass}</td>
            <td>{item.NewSection}</td>
            <td>{item.PromotedByName}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="15">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPageNo(1);
    fetchPromotedStudents();
  };

  return (
    <>
      <ToastContainer />
      <ReportsMenu />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Reports/ReportsDashboard">Reports</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Promotion Report
                  </li>
                </ol>
              </nav>
              <div className="page-title">Promotion Report</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <a
                  href="javascript:;"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFilteres"
                  className="button button-white button-icon"
                >
                  Filters
                  <i className="ri-filter-3-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`collapse ${showFilters ? "show" : ""}`}
        id="collapseFilteres"
      >
        <div className="page-content">
          <div className="container">
            <div className="card mb-2">
              <div className="card-body p-md-4">
                <Form onSubmit={handleSearch}>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Student ID:</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Student ID"
                          value={registrationNo}
                          onChange={(e) => setRegistrationNo(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>From Date :</label>
                        <input
                          type="date"
                          className="form-control"
                          onChange={(e) => setDateFrom(e.target.value)}
                          max={moment().format(config.date_format_input)}
                          min={moment()
                            .subtract(4, "months")
                            .format(config.date_format_input)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>To Date :</label>
                        <input
                          type="date"
                          className="form-control"
                          onChange={(e) => setDateTo(e.target.value)}
                          max={moment().format(config.date_format_input)}
                          min={moment()
                            .subtract(4, "months")
                            .format(config.date_format_input)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>Old Wing:</label>
                        <select
                          name="OldWing_Id"
                          onChange={(e) => setOldWingId(e.target.value)}
                          className="form-select"
                        >
                          <option value="0">---All---</option>
                          <WingsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label>New Wing:</label>
                        <select
                          name="NewWing_Id"
                          onChange={(e) => setNewWingId(e.target.value)}
                          className="form-select"
                        >
                          <option value="0">---All---</option>
                          <WingsDropDown />
                        </select>
                      </div>
                    </div>

                    {loaddata ? (
                      <div className="col-md-1 text-center">
                        <div>
                          <div>
                            <Spinner
                              className="mt-4"
                              animation="border"
                              role="status"
                            ></Spinner>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-1 text-center offset-6 mt-3">
                        <div className="form-group text-end mt-2">
                          <a
                            type="button"
                            onClick={handleSubmitForCvs}
                            className="print-icon"
                          >
                            <span>
                              <i className="ri-file-excel-2-line"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    )}
                    <div className="col-md-2 mt-3 text-end">
                      <div className="form-group">
                        <button
                          type="submit"
                          className="button button-primary w-100"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <table className="table table-theme">
                <thead>
                  <tr>
                    <th colSpan={15}>
                      {totalRecords} {totalRecords === 1 ? "Record" : "Records"}{" "}
                      Found
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>ID</th>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    <th>Date</th>
                    <th>Old Wing</th>
                    <th>Old Class</th>
                    <th>Old Section</th>
                    <th>New Wing</th>
                    <th>New Class</th>
                    <th>New Section</th>
                    <th>Promoted By</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan="15">
                        <Spinner animation="border" role="status"></Spinner>
                      </td>
                    </tr>
                  ) : (
                    renderPromotedStudents()
                  )}
                </tbody>
              </table>
              {totalRecords > 10 && (
                <div className="pagination-wrap">
                  <div className="row align-items-center">
                    <div className="col-md-2 form_default">
                      <div className="d-flex align-items-center">
                        <label className="me-2" style={{ fontSize: "15px" }}>
                          Page Size
                        </label>
                        <div className="form-group">
                          <select
                            className="form-select"
                            style={{ width: "100px" }}
                            onChange={(e) => {
                              setPageNo(1);
                              setPageSize(parseInt(e.target.value));
                            }}
                            value={pageSize}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <Pagination
                      pageNo={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="card mt-2">
            <div className="card-body p-md-4">
              <div className="row">
                <div className="col-md-12 text-end">
                  <div className="form-group text-end">
                    <NavLink
                      className="button button-primary"
                      to={`/Reports/PromotionReportPrint?OldWing_Id=${oldWingId}&NewWing_Id=${newWingId}&OldClass_Id=${oldClassId}&NewClass_Id=${newClassId}&OldSection_Id=${oldSectionId}&NewSection_Id=${newSectionId}&Student_ID=${registrationNo}&DateFrom=${
                        dateFrom ? moment(dateFrom).format("YYYY-MM-DD") : ""
                      }&DateTo=${
                        dateTo ? moment(dateTo).format("YYYY-MM-DD") : ""
                      }&Is_Active=${
                        isActive === null ? "" : isActive ? "1" : "0"
                      }`}
                      target="_blank"
                    >
                      Print Report
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromotionReport;
